import { FilterTypeEnum } from 'src/app/reports/enums/filter-type.enum';

export class Filter {
    ReportEntityId: number;
    Legend: string;
    FinalLegend: string;
    EntityId: number;
    Name: string;
    Required: boolean;
    IsFileUpload: boolean;
    ColumnType: ColumnType;
    MaxLength: number;
    Type: FilterTypeEnum;
    Order: number;
    EntityListId: number;
}


export class ColumnType {
    Id: number;
    ColumnType: string;
    SystemType: string;
    ProviderType: number;
}
